import React, {Component} from 'react';

import HorizontalSelectOption from './HorizontalSelectOption';

class AtCostOptions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: ""
		}
	}

	onSelect = e => {
		e.preventDefault();
		const val = this.state.selected === e.target.id ? "" : e.target.id;
		this.setState({
			...this.state,
			selected: val
		});
		this.props.onSelect(val);
	}

	render() {
		const {selected} = this.state;
		return (
			<div className="expenses-type-container">
				<HorizontalSelectOption value="Limit" selected={selected} onSelect={this.onSelect} style={{width: "45%", borderTopLeftRadius: "3px", borderBottomLeftRadius: "3px"}} />
				<HorizontalSelectOption value="No Limit" selected={selected} onSelect={this.onSelect} style={{width: "55%", borderTopRightRadius: "3px", borderBottomRightRadius: "3px"}} />
			</div>
		);
	}
}

export default AtCostOptions;